import { useQuery } from "@apollo/client";
import { ADMIN_USERNAME } from "../component/Chart/Charts";
import { GET_ME } from "../query/UserQueries";

export const useIsAdmin = () => {
  const { data } = useQuery(GET_ME);
  const currentUser = data?.me;
  return currentUser?.username === ADMIN_USERNAME;
};
